import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  WorkType,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.repairer}worktype`;

const getWorkTypesBySellerQuery = async ({
  sellerId,
  fileId,
  name,
}: {
  sellerId: string;
  fileId?: string;
  name?: string;
}): Promise<BackResponse<WorkType[]> | BackResponseFailure> => {
  try {
    return await apiCall<BackResponse<WorkType[]>>(
      buildUrl(ENDPOINT, {
        sellerId,
        fileId,
        name,
      }),
      { method: SUPPORTED_METHODS.GET },
    );
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};

export default getWorkTypesBySellerQuery;
